






















import { Component, Vue } from "vue-property-decorator";
import HNotification from "@/components/base/h-notification/index.vue";

@Component({
  name: "HLayout",
  components: {
    HNotification,
    HNavigation: () => import("@/components/layouts/h-navigation.vue")
  }
})
export default class HLayout extends Vue {
  private get key() {
    return this.$route.path;
  }
}
